import { render, staticRenderFns } from "./small.vue?vue&type=template&id=6c6bd742&scoped=true"
import script from "./small.vue?vue&type=script&lang=js"
export * from "./small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6bd742",
  null
  
)

export default component.exports